const s = "af.filter-sidebar.number-of-fonts-slider-changed", e = class e extends CustomEvent {
  constructor(a, o) {
    super(s, { detail: { handleName: a, value: o }, bubbles: !0, composed: !0 });
  }
};
e.EVENT_NAME = s;
let t = e;
export {
  s as EVENT_NAME,
  t as default
};
//# sourceMappingURL=NumberOfFontsSliderEvent.js.map
